
export const width_bwcdiamond = {
    width_i: 30,
}

export const symbol_status_bwcdiamond_eng = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 288,
        Ypos_img: 245,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium breve`,
        Xpos_img: 288,
        Ypos_img: 302,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Bifidobacterium lactis`,
        Xpos_img: 288,
        Ypos_img: 356,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium longum`,
        Xpos_img: 288,
        Ypos_img: 410,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 288,
        Ypos_img: 465,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus gasseri`,
        Xpos_img: 288,
        Ypos_img: 520,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Lactobacillus helveticus`,
        Xpos_img: 288,
        Ypos_img: 575,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus paracasei`,
        Xpos_img: 288,
        Ypos_img: 627,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus plantarum`,
        Xpos_img: 288,
        Ypos_img: 682,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 288,
        Ypos_img: 738,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 288,
        Ypos_img: 792,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Streptococcus thermophilus`,
        Xpos_img: 288,
        Ypos_img: 850,
        page: 9,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]

export const symbol_status_bwcdiamond_thai = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 288,
        Ypos_img: 185,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium breve`,
        Xpos_img: 288,
        Ypos_img: 242,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Bifidobacterium lactis`,
        Xpos_img: 288,
        Ypos_img: 297,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium longum`,
        Xpos_img: 288,
        Ypos_img: 350,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 288,
        Ypos_img: 405,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus gasseri`,
        Xpos_img: 288,
        Ypos_img: 460,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Lactobacillus helveticus`,
        Xpos_img: 288,
        Ypos_img: 515,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus paracasei`,
        Xpos_img: 288,
        Ypos_img: 570,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus plantarum`,
        Xpos_img: 288,
        Ypos_img: 625,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 288,
        Ypos_img: 678,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 288,
        Ypos_img: 734,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Streptococcus thermophilus`,
        Xpos_img: 288,
        Ypos_img: 790,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]